import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M3 4V.667M1.335 2.333h3.333m4-.333L7.511 5.006c-.188.489-.282.733-.428.939a2 2 0 0 1-.471.47c-.206.147-.45.24-.939.429L2.667 8l3.006 1.156c.489.188.733.282.939.428a2 2 0 0 1 .471.471c.146.206.24.45.428.939L8.667 14l1.156-3.006c.188-.489.282-.733.429-.939q.196-.275.47-.47c.206-.147.45-.241.94-.43L14.667 8l-3.006-1.156c-.488-.188-.733-.282-.938-.428a2 2 0 0 1-.471-.471c-.147-.206-.24-.45-.429-.94z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }